import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import ForgotPassword from './ForgotPassword'
import styles from '../_auth.css'

const mapStateToProps = () => ({
})

const mapDispatchToActions = {
  push,
}

export const messages = {
}

export class ForgotPasswordPage extends Component {

  static propTypes = {
    push: PropTypes.func,
  }

  handleClickLogin = () => {
    this.props.push('/auth/login')
  }

  render () {
    return (
      <div className={styles.container}>
        <ForgotPassword
          onClickLogin={this.handleClickLogin}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(ForgotPasswordPage)
